import { CommonModule } from '@angular/common';
import { Component, Inject, NgModule, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

export interface InfoDialogData {
  text: string;
  buttonText: string;
  title: string;
}

@Component({
    selector: 'ts-info-dialog',
    templateUrl: './info-dialog.component.html',
    styleUrls: ['./info-dialog.component.scss'],
    standalone: false
})
export class InfoDialogComponent {
  constructor(
    @Optional() public readonly dialogRef: MatDialogRef<InfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: Readonly<InfoDialogData>
  ) {}
}

@NgModule({
  imports: [CommonModule, TranslateModule, MatDialogModule],
  declarations: [InfoDialogComponent],
  exports: [InfoDialogComponent],
})
export class InfoDialogComponentModule {}
